import { render, staticRenderFns } from "./SARSTracker.vue?vue&type=template&id=42870a92&scoped=true"
import script from "./SARSTracker.vue?vue&type=script&lang=js"
export * from "./SARSTracker.vue?vue&type=script&lang=js"
import style0 from "./SARSTracker.vue?vue&type=style&index=0&id=42870a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42870a92",
  null
  
)

export default component.exports